import { useMutation } from "@tanstack/react-query";

import { sessionApi } from "@shared/api";

export const useSignOut = () => {
  const { error, mutateAsync, isPending } = useMutation({
    mutationFn: () =>
      sessionApi.postApiV1SessionsLogout(
        { requestSource: "WEB" },
        { withCredentials: true },
      ),
  });

  return { error, sessionLogout: mutateAsync, isPending };
};
